import { Controller } from "@hotwired/stimulus";
import { showOverlay, hideOverlay } from "../utils/modals";
export default class extends Controller {
  static targets = ["content"];

  intialClassName;

  initialize() {
    this.intialClassName = this.element.className;
    this.handleEscKey = this.handleEscKey.bind(this);
    this.close = this.close.bind(this);
    this.open = this.open.bind(this);
  }

  contentTargetConnected() {
    if (this.contentTarget.dataset.sidebarClass) {
      this.contentTarget.dataset.sidebarClass
        .split(/\s+/)
        .forEach((className) => {
          this.element.classList.add(className);
        });
    }
    this.open();
  }

  contentTargetDisconnected() {
    this.close();
    this.element.className = this.intialClassName;
  }

  open() {
    showOverlay().addEventListener("click", this.close);
    this.element.classList.add("open");
    document.addEventListener("keyup", this.handleEscKey);
  }

  close() {
    hideOverlay();
    this.element.classList.remove("open");
    this.element.removeAttribute("src");
    this.element.removeAttribute("complete");
    document.removeEventListener("keyup", this.handleEscKey);
  }

  handleEscKey(e) {
    if (e.key === "Escape") {
      this.close();
    }
  }
}
